import { Producto } from "./producto";

export class NotaDebitoDetalle {
    public constructor(
        public id: String = "",
        public razon: String = "",
        public valor: number = 0,
        public desc_valor: number = 0,
        public desc_porcent: number = 0,
        public subtotal: number = 0,
        public iva: number = 0,
        public porct_iva: number = 0,
        public total: number = 0,
        public detalle: String = "",
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public nota_credito_id: String = "",
        public producto_id: String = "",
        public status: String = "",
        public usuario_id: String = "",

        public producto: Producto = new Producto(),
        public cod_iva: number = 0,
    ){
        //
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/nota-debito-detalle.ts